// extracted by mini-css-extract-plugin
export default {"DoctorStamp":"TreatmentContract_DoctorStamp__Y5o3L","heading":"TreatmentContract_heading__J5oxh"};